/* eslint-disable @typescript-eslint/no-restricted-imports */
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom-v5-compat';
// import {
//   type Location,
//   useLocation as useCompatLocation,
//   useParams as useCompatParams,
// } from 'react-router-dom-v5-compat';

// import { useHistory as useLegacyHistory } from 'react-router-dom';

export {
  BrowserRouter,
  Redirect,
  Prompt,
  MemoryRouter,
  Route,
  Switch,
  useParams,
  useLocation,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';

export {
  CompatRouter,
  CompatRoute,
  useNavigate,
  useMatch,
  matchPath,
  generatePath,
  Link,
  NavLink,
  type LinkProps,
} from 'react-router-dom-v5-compat';

// export const useParams = <
//   Params extends { [K in keyof Params]?: string } = {},
// >(): Params => {
//   return useCompatParams() as unknown as Params;
// };
//
// export const useLocation = <
//   Params extends { [key: string]: unknown } = {},
// >(): Location<Params | undefined> => {
//   return useCompatLocation() as Location<Params | undefined>;
// };

// // @ts-expect-error post upgrade will be updated
// export const useHistory: typeof useLegacyHistory = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//
//   return {
//     push: (path: string, state?: any) => navigate(path, { state }),
//     replace: (path: string, state?: any) =>
//       navigate(path, { replace: true, state }),
//     go: (n: number) => window.history.go(n),
//     goBack: () => window.history.back(),
//     goForward: () => window.history.forward(),
//     location, // Mimic `history.location`
//   };
// };

/** matchPath decodes %2F; restore it before treating a matched segment as a raw URL/key. */
export const getEncodedPathParam = (value: string | undefined) =>
  value?.replace(/\//g, '%2F');

/** Keep the original suffix bytes, including encoded slashes and trailing slashes. */
export const getAppPathname = (pathname: string): string | undefined => {
  const match = matchPath(
    { path: '/company/:companyKey/app/:appKey/*', end: false },
    pathname
  );
  if (!match) return undefined;
  const suffix = pathname.slice(match.pathnameBase.length);
  // The old splat requires the slash after appKey. Preserve that root distinction.
  return suffix.startsWith('/') ? suffix : undefined;
};

// This hook is useful only within /company/:id/app/:id/ URL space.
export const useAppLocation = () => {
  const location = useLocation();
  const pathname = getAppPathname(location.pathname);
  const suffix =
    pathname === undefined
      ? undefined
      : pathname + location.search + location.hash;
  const appUrl = suffix === '/' ? undefined : suffix;

  return useMemo(() => ({ appUrl }), [appUrl]);
};
